<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>Edit Sales channel</h2>
        </div>
        
        <div slot="body">
            <div class="col-sm-12 py-3">
                <sales-channel-form :salesChannel="tempSalesChannel"></sales-channel-form>
            </div>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="close">Cancel</button>
            <button type="button" class="btn wider mr-3" @click="save">Save</button>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal'
    import salesChannelForm from './salesChannelForm'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data() {
            return {
                tempSalesChannel: null
            }
        },
        created() {
            this.tempSalesChannel = JSON.parse(JSON.stringify(this.getSelectedSalesChannel));
        },
        computed: {
            ...mapGetters([
                'getSelectedSalesChannel'
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'setSelectedSalesChannel',
                'deleteSalesChannel',
                'updateSalesChannel',
                'downloadSalesChannels'
            ]),
            deleteChannel(salesChannel) {
                this.deleteSalesChannel(salesChannel);
            },
            save() {
                this.updateSalesChannel(this.tempSalesChannel).then(success => {
                    if (success == true) {
                        this.closeModal();
                        this.downloadSalesChannels();
                    }
                })
            },
            close() {
                this.setSelectedSalesChannel(null);
                this.closeModal();
            },
        },
        components: {
            Modal,
            salesChannelForm
        }
    }
</script>

<style lang="scss" scoped>
    .langPicker{
        width: 250px;
    }
</style>



// WEBPACK FOOTER //
// editSalesChannel.vue?4f8c64d4